<template>

  <div>
    <CallRecordsTable
      ref="recordsTable"
      :branch-options="branchOptions"
      @fetchCallRecording="openCallRecording"
    />

    <!-- CALL RECORDING AUDIO -->
    <call-recording-audio
      :modalVisible="audioModalVisible"
      :id="callRecordingId"
      :start="callRecordingDate"
      :duration="callRecordingDuration"
      :caller-name="callRecordingCallerName"
      :caller-num="callRecordingCallerNum"
      :dialed-num="callRecordingDialedNum"
      :disposition="callRecordingDisposition"
      :startDB="this.startDB"
      :tenantId="callRecordingTenant"
      @closeModal="closeAudioModal"
    />
  </div>

</template>

<script>
import CallRecordsTable from './components/call-recordings-table';
import CallRecordingAudio from './components/call-recording-audio';
import feathersClient from "@/feathers/feathers-client";
import moment from "moment";
export default {
  name: 'CallRecording',
  components: {
    CallRecordsTable,
    CallRecordingAudio
  },
  data() {
    return {
      branchOptions: [],
      callRecordingId: null,
      activeNavTab: null,
      resized: false,
      audioModalVisible: false,
      callRecordingDate: null,
      callRecordingTenant: null,
      callRecordingDuration: null,
      callRecordingDisposition: null,
      callRecordingCallerNum: null,
      callRecordingCallerName: null,
      callRecordingDialedNum: null,
      startDB: null,
    }
  },
  methods: {
    queryBranches(){
      feathersClient.service('branches').find({
        query: {
          tenantId: this.selectedTenant.id
        }
      }).then( res => {
        this.branchOptions = res;
      }).catch(() => {
        this.branchOptions = [];
      });
    },

    __resizeHandler: _.throttle(function (e) {
      if (this.resized) {
        setTimeout(() => {
          this.$refs.inboundPlot.chart.resize();
          this.$refs.outboundPlot.chart.resize();
        }, 1000)
      }
      this.resized = true;
    }, 700),
    openCallRecording(call) {
      const {uniqueId, start, disposition, dialedNum, callerIdName, callerIdNumber, duration} = call;
      this.audioModalVisible = true;
      this.callRecordingId = uniqueId;
      this.callRecordingDate = this.timeFormatter(start);
      this.callRecordingDuration = duration;
      this.callRecordingCallerNum = callerIdNumber;
      this.callRecordingDialedNum = dialedNum;
      this.callRecordingDisposition = disposition;
      this.callRecordingCallerName = callerIdName;
      this.startDB = start;
    },
    closeAudioModal() {
      this.audioModalVisible = false;
      this.callRecordingId = null;
    },
    timeFormatter(value) {
      const offsetMinutes = Math.abs(this.userOffsetMinutes);
      return this.userOffsetMinutes < 0
        ? moment(value)
          .subtract(offsetMinutes, "minutes")
          .format("M/DD h:mm A")
        : moment(value)
          .add(offsetMinutes, "minutes")
          .format("M/DD h:mm A");
    }
  },
  computed: {
    selectedTenant(){
      return this.$store.state.selectedTenant;
    },
    user(){
      return this.$store.state.auth.user;
    },
    userIsReportsAdmin(){
      const roles = [1,3,9,11,12];
      return roles.includes(+this.user.userRole);
    },
    userOffsetMinutes(){
      return this.$store.state.userTimeOffset;
    }
  },
  watch: {
    selectedTenant(){
      this.queryBranches();
    }
  },
  mounted() {
    //pass the branches to the plots
    this.queryBranches();
  }
}
</script>
